// @flow strict

import React from 'react';
import PropTypes from 'prop-types';

import { MenuItem } from './menuItem.js';

import * as styles from './menuCompany.module.less';

export const MenuCompany = ({ data }) => {
  // Lay the items out column-major across two columns. Using an explicit row
  // count lets the grid share row tracks between both columns, so items that
  // face each other stay vertically aligned even when their subtitles differ
  // in length.
  const rowCount = Math.ceil(data.items.length / 2);

  return (
    <div className={styles.itemsWrapper}>
      <div
        className={styles.itemsGrid}
        style={{ gridTemplateRows: `repeat(${rowCount}, auto)` }}
      >
        {data.items.map((companyItem) => {
          return <MenuItem key={companyItem.name} data={companyItem} />;
        })}
      </div>
      <div className={styles.lastCol}>
        <ul className={styles.companyLinks}>
          {data.links.map((link) => {
            return (
              <li key={link.name}>
                <a href={link.href}>{link.name}</a>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

MenuCompany.propTypes = {
  data: PropTypes.object,
};
